import { render, staticRenderFns } from "./NICUInvoices.vue?vue&type=template&id=caa2f44a&scoped=true"
import script from "./NICUInvoices.vue?vue&type=script&lang=js"
export * from "./NICUInvoices.vue?vue&type=script&lang=js"
import style0 from "./NICUInvoices.vue?vue&type=style&index=0&id=caa2f44a&prod&lang=css"
import style1 from "./NICUInvoices.vue?vue&type=style&index=1&id=caa2f44a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa2f44a",
  null
  
)

export default component.exports